import { DEFAULT_PIK_REGIONS } from '../constants/config/pik';

export function isPikRegion(region: number, rsPikRegions: number[] | null) {
  const pikRegions = Array.isArray(rsPikRegions) ? rsPikRegions : DEFAULT_PIK_REGIONS;

  return pikRegions.includes(region);
}
